/* 
Methods for easily creating strictly formatted messages that can be passed 
between iframes and the source page. 
*/
const Events = require('../app/events.js');

var Message = {

  // Used on field/iframe creation
  // details are e.g. style, placeholder, classes
  create: function(details) {
    return this._generic('create', details);
  },

  // Sent from the cvv iframe to the card number and expiry iframes, to
  // indicate that cvv is being used on the page. 
  updateCvvPresent: function() {
    return this._generic('cvvPresent');
  },

  // sent back from an iFrame to the source window after creation. 
  // used to update the dimensions of the iFrame to fit the created input.
  updateIFrame: function(type, inputHeight) {
    return this._generic('updateIFrame', { type: type, inputHeight: inputHeight} );
  },

  changeValue: function(newValue, autofill) {
    return this._generic('changeValue', { newValue: newValue, autofill: autofill });
  },

  callback: function(eventName, event) {
    const details = {
      eventName: eventName,
      event: event,
    };
    return this._generic('callbackEvent', details);
  },

  // Sent from source window to the iFrames to set up an 
  // event callback that can be triggered on the iframe, 
  // back to the source.
  registerCallback: function(eventName) {
    const details = {
      eventName: eventName,
    };
    return this._generic('registerCallback', details);
  },

  // Sent from the card number window to the cvv window when the card brand
  // changes, so that cvv can validate against the current brand.
  brandChange: function(brand) {
    const details = {
      brand: brand,
    };
    return this._generic('brandChange', details);
  },

  // Sent from the card number to the cvv window when cvv asks for it (as opposed
  // to when brand changes -- above). Needed in the case that cvv has been mounted
  // or re-mounted after the brand has been updated.
  askForBrand: function(askerField) {
    const details = {
      asker: askerField,
    };
    return this._generic('askForBrand', details);
  },

  // Sent from the source window to the card number iframe to start the 
  // tokenization process (validation and ajax request).
  // The token will be created associated with the specified Merchant GUID.
  beginTokenization: function(merchantGuid) {
    const details = {
      merchantGuid: merchantGuid,
    };
    return this._generic('beginTokenization', details);
  },

  tokenResponse: function(result, code, errorOrToken, last4, expiryMonth, expiryYear) {
    let details = { event: {} };
    details.event.code = code;
    if(result === Events.error) {
      details.event.error = errorOrToken;
    } else {
      details.event.token = errorOrToken;
      details.event.last4 = last4;
      details.event.expiryMonth = expiryMonth;
      details.event.expiryYear = expiryYear;
    }
    return this._generic('tokenResponse', details);
  },

  // Sent from one iframe input to another requesting validation information.
  validationRequest: function() {
    return this._generic('validationRequest');
  },

  // Sent from one iframe back to the one that requested validation information.
  // If valid, message includes the value of the field.
  validationResponse: function(field, valid, value) {
    const details = {
      field: field,
      valid: valid, 
      value: value, 
    };
    return this._generic('validationResponse', details);
  },

  // Sent from one iframe input to another requesting input focus.
  focus: function() {
    return this._generic('focus');
  },

  // Sent from one iframe input to another requesting input blur.
  blur: function() {
    return this._generic('blur');
  },

  // Sent from one iframe input to another requesting input clear.
  clear: function() {
    return this._generic('clear');
  },

  // Used to update field/iframe
  // details are e.g. style, placeholder, classes
  update: function(details) {
    return this._generic('update', details);
  },

  // Create an empty named message
  _generic: function(name, details) {
    return {
      name: name,
      details: details,
    };
  },
};

module.exports = Message;


// WEBPACK FOOTER //
// ./app/message.js